<template>
  <div style="background-color: #f5f5f5">
    <div style="margin-left: 10%;padding-left:80px;padding-top:50px;margin-top: 70px;background-color: #ffffff;width: 80%;padding-bottom: 50px">
      <h1>{{mainData.name}}</h1>
      <p style="padding-top: 20px">发布于  {{mainData.date}}</p>
      <p style="padding-top: 20px">静态壁纸  /  {{mainData.category_name}}</p>
      <p style="padding-top: 20px;padding-bottom: 30px">{{mainData.tags}}</p>
      <row>
        <Col span="5" style="text-align: center">
          <img :src="mainData.url" width="400"/>
          <Button @click="clickCopyright" target="_blank" size="large" icon="ios-download-outline" ghost type="info" style="margin-top: 20px;margin-left: 10px">商用授权下载</Button>
          <Button target="_blank" size="large" icon="ios-download-outline" :to="mainData.url+'?download'" ghost type="info" style="margin-top: 20px;margin-left: 5px">下载原图</Button>
          <p style="padding-top: 20px;text-align: left">该壁纸已被浏览{{data.clickCount}}次</p>
        </Col>
        <Col span="8" offset="8">
          <h2 style="">热门下载</h2>
          <img v-for="i in data.hot" :src="i.url" width="200" style="margin: 10px" @click="clickImage(i.id)">
        </Col>
      </row>
    </div>
    <div style="margin-top: 40px;margin-left: 10%;background-color: #ffffff;text-align: center;width: 80%;">
      <h1 style="padding: 40px 0 0 0">您可能对以下的也感兴趣</h1>
      <h3 style="padding: 10px 0 0 0">You may be interested</h3>
      <img v-for="i in data.guess" :src="i.url" width="200" style="margin: 50px" @click="clickImage(i.id)">
    </div>
  </div>
</template>

<script>
  import {ajaxFetch} from '../utils'
  export default {
    name: 'DetailImgPage',
    data () {
      return {
        data: {},
        mainData: {},
        id: ''
      }
    },
    mounted: function () {
      this.id = this.$route.query.id
      this.listByCategory(this.id)
    },
    methods: {
      listByCategory: function (id) {
        ajaxFetch('post','/client/productTable/findById',{id: id},(response) => {
          if (response.code === 200) {
            this.data = response.data
            this.mainData = this.data.main
          } else {

          }
        }, (err) => {
          console.log(err)
        } )
      },
      clickImage: function (id) {
        this.$router.push({name: 'detailImgPage', query: {id: id}})
      },
      clickCopyright () {
        this.$Modal.info({
          title: '商用授权',
          content: '声明：视一壁纸素材为原创或已获得相关权利人授权，图片受著作权法保护，著作权及相关权利归本网站所有，未经许可不可商用.<p/>如需商用,请点击网页底部QQ在线联系.'
        })
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DetailImgPage.vue